import type { ComponentProps, ReactNode } from 'react';

import { cn } from '@nucleus-commerce/ui/lib/utils';

/** Dense label / value rows for detail cards and system panels. */
export function DetailList({ className, ...props }: ComponentProps<'dl'>) {
  return (
    <dl className={cn('divide-border flex flex-col divide-y text-sm', className)} {...props} />
  );
}

export interface DetailRowProps {
  label: ReactNode;
  children: ReactNode;
  className?: string;
}

export function DetailRow({ label, children, className }: DetailRowProps) {
  return (
    <div
      className={cn(
        'flex items-baseline justify-between gap-4 py-2 first:pt-0 last:pb-0',
        className,
      )}
    >
      <dt className="text-muted-foreground shrink-0">{label}</dt>
      <dd className="min-w-0 text-right">{children}</dd>
    </div>
  );
}
